import React from 'react';
import { type Theme, useStyletron } from 'baseui';
import type { StyleObject } from 'styletron-react';
const getCornerStyle = (theme: Theme): StyleObject => ({
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  color: theme.colors.contentPrimary,
  ...theme.typography.LabelXSmall
});
export const TimelineCorner = ({
  title
}: {
  title: string;
}) => {
  const [css, theme] = useStyletron();
  return <div className={css(getCornerStyle(theme))}>{title}</div>;
};